import api from "../api";

const controller = '/NaoPrevistoRecursoParaExecucao';

export interface RecursosParaExecucaoSolicitacao {
    id: string;
    index: number;
    codProjeto: string;
    nomeProjeto: string;
    numeroTotvs: string;
    valorDisponibilizado?: number;
}

export const getRecursosParaExecucaoSolicitacao = async (id: string) => {
    return await api.get<RecursosParaExecucaoSolicitacao[]>(`${controller}/listar/${id}`, {}, {}, 'false');
}

export const createRecursoParaExecucaoSolicitacao = async (item: { solicitacaoNaoPrevistoId: string }) => {
    return await api.post(`${controller}`, item);
}

export const updateRecursosParaExecucaoSolicitacao = async (item: RecursosParaExecucaoSolicitacao) => {
    return await api.put(`${controller}`, item);
}

export const deleteRecursosParaExecucaoSolicitacao = async (id: string) => {
    return await api.delete(`${controller}/${id}`);
}

export const getListaProjetosRecursosParaExecucao = async (id: string) => {
    return await api.get<any[]>(`${controller}/listarProjetos/${id}`);
}